// extracted by css-extract-rspack-plugin
export default {"hero":"HeroSection-module__hero__Qw6J9","logos":"HeroSection-module__logos__U8O76","pillars":"HeroSection-module__pillars__R5moQ"};